import request from '@/utils/request'

const api = {
  CORS: 'https://cors.v-dk.com/',
  DFZ_IAS_ZGBJDS: 'https://ias.zgbjds.com/',
  PAGE_BOOK_API: 'https://ias.zgbjds.com/ias-api/',
  DFZ_TOOLBOX_TP_PUBLIC:
    'https://ias.zgbjds.com/dfz-api/dfz-toolbox/tp/public/',
}

// 将搜索的文字拆分
export const geTextSplitting = (keywords) => {
  return fetch(api.DFZ_TOOLBOX_TP_PUBLIC + '?s=nlp/lexer/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
    },
    body: 'keywords=' + keywords,
    // credentials: 'same-origin',
    // headers: new Headers({ 'Content-Type': 'application/json' }),
  }).then((response) => response.text()) //定义返回的类型和数据格式
}

// 书籍库书籍分类
export const getBookLibraryClassificationBook = () => {
  return request.get(api.PAGE_BOOK_API + '?api=book_cat_tree')
}

// 书籍库书籍关键字
export const getBookLibraryKeywordBooks = (value: string) => {
  return request.get(
    api.DFZ_TOOLBOX_TP_PUBLIC + `?s=neo/searchBook/*/*/${value}/*/*`,
  )
}

// 书籍库大纲关键字
export const getBookLibraryKeywordOutlines = (value: string) => {
  return request.get(
    api.DFZ_TOOLBOX_TP_PUBLIC + `?s=neo/searchNav/*/${value}/*/*/*`,
  )
}

interface BookLibrarySearch {
  page: number
  mainText?: string
  assortId?: string
  bookKeywords?: string
  outlineKeywords?: string
}
// 书籍库搜索
export const getBookLibrarySearch = ({
  page,
  mainText,
  assortId,
  bookKeywords,
  outlineKeywords,
}: BookLibrarySearch) => {
  return request.get(
    api.DFZ_TOOLBOX_TP_PUBLIC +
      `?s=neo/searchBooks/${mainText ? mainText : '*'}/${
        outlineKeywords ? outlineKeywords : '*'
      }/${bookKeywords ? bookKeywords : '*'}/${assortId ? assortId : '*'}/${
        page ? page : '*'
      }`,
  )
}

// 书籍库书籍详情
export const getBookLibraryBookDetails = (uuid: string) => {
  return api.DFZ_IAS_ZGBJDS + '?find_book_by_uuid=' + uuid + '&action=ias_page'
}

// 书籍库上下文数据
export const getBookLibraryContentData = (uuid) => {
  return request.get(api.DFZ_TOOLBOX_TP_PUBLIC + `?s=neo/getBook/${uuid}/1`)
}

// 书籍库上下文详情点击
export const getBookLibraryContentDetails = (value: string) => {
  return request.get(
    api.DFZ_TOOLBOX_TP_PUBLIC + `?s=neo/searchBooks/*/${value}/*/*/*`,
  )
}

// 书籍库书籍PDF
export const getBookLibraryBookPDFUrl = (uuid: string, page: number) => {
  return (
    api.DFZ_IAS_ZGBJDS +
    `?find_book_by_uuid=${uuid}&action=pdf_file&pdf_page=${page}`
  )
}

// 新闻库内容源站
export const getNewsLibraryContentSourceStation = () => {
  return request.get(api.PAGE_BOOK_API + `?api=news_cat`)
}

interface NewsLibrarySearch {
  page: number
  stationId: string
  newsKeywords: string
  subtitleKeywords: string
  timeSlot: string[]
}
// 新闻库搜索
export const getNewsLibrarySearch = ({
  page,
  stationId,
  newsKeywords,
  subtitleKeywords,
  timeSlot,
}: NewsLibrarySearch) => {
  return request.get(
    api.DFZ_TOOLBOX_TP_PUBLIC +
      `?s=neo/searchNews/${newsKeywords ? newsKeywords : '*'}/${
        subtitleKeywords ? subtitleKeywords : '*'
      }/${timeSlot ? timeSlot[0] : '*'}/${timeSlot ? timeSlot[1] : '*'}/${
        stationId ? stationId : '*'
      }/${page ? page : '*'}`,
  )
}

interface NewsLibraryExport {
  stationId: string
  newsKeywords: string
  subtitleKeywords: string
  timeSlot: string[]
}
// 新闻库导出
export const getNewsLibraryExport = ({
  stationId,
  newsKeywords,
  subtitleKeywords,
  timeSlot,
}: NewsLibraryExport) => {
  return request.get(
    api.DFZ_TOOLBOX_TP_PUBLIC +
      `?s=neo/searchNewsAll/${newsKeywords ? newsKeywords : '*'}/${
        subtitleKeywords ? subtitleKeywords : '*'
      }/${timeSlot ? timeSlot[0] : '*'}/${timeSlot ? timeSlot[1] : '*'}/${
        stationId ? stationId : '*'
      }`,
  )
}
interface NewsLibraryExportDownload {
  ids: string[]
  isExportNeedImg: boolean
  stationId: string
  timeSlot: string[]
}
// 新闻库导出
export const getNewsLibraryExportDownload = ({
  ids,
  isExportNeedImg,
  stationId,
  timeSlot,
}: NewsLibraryExportDownload) => {
  // return request.get(
  //   api.DFZ_TOOLBOX_TP_PUBLIC +
  //     `?s=neo/exportNews/${ids.join('_')}/${isExportNeedImg ? 1 : 0}/${
  //       timeSlot[0]
  //     }/${timeSlot[1]}/${stationId}`,
  // )
  return fetch(
    api.DFZ_TOOLBOX_TP_PUBLIC +
      `?s=neo/exportNews/${ids.join('_')}/${isExportNeedImg ? 1 : 0}/${
        timeSlot[0]
      }/${timeSlot[1]}/${stationId}`,
    {
      method: 'GET',
      // credentials: 'same-origin',
      // headers: new Headers({ 'Content-Type': 'application/json' }),
    },
  )
}
